import { RuntimeConfiguration } from './lib/runtime-configuration';
import { environment } from '../environments/environment';

export function createFirebase() {
  return RuntimeConfiguration.getInstance().getFirebase(environment.firebase);
}
